import { ArrowUpRight, MessageSquareText, PhoneCall } from "lucide-react";

const Footer = ({ settings }) => {
  const phone = settings.phone.replace(/[^0-9+]/g, "");
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-top section-wrap"><div><p className="eyebrow">Sosas Hardwood Floors</p><h2>Floors for your<br /><em>home.</em></h2></div><div className="footer-actions"><a className="button button-primary" href={`tel:${phone}`} data-testid="footer-phone-link"><PhoneCall size={17} /> {settings.phone}</a><a className="button button-outline" href={`sms:${phone}`} data-testid="footer-text-link"><MessageSquareText size={17} /> Text us</a></div></div>
      <div className="footer-bottom section-wrap"><p>{settings.working_hours}</p><p>Serving Pennsylvania · Delaware · New Jersey</p><a href="#top" data-testid="footer-back-to-top">Back to top <ArrowUpRight size={15} /></a></div>
      <div className="footer-wordmark">SOSAS <span>HARDWOOD FLOORS</span></div>
    </footer>
  );
};

export default Footer;
